define('models/SetupPrivateModel',['underscore','ObjectModel','site_vars',
    'models/AddressCollection',
    'models/CartModel',
    'models/CustomerModel',
    'models/SyncModel',
    'models/MessageCollection',
], function (_, ObjectModel,
    site_vars,
    AddressCollection,
    CartModel,
    CustomerModel,
    SyncModel,
    MessageCollection
)
{
    //
    // Model Setup Private
    //
    
    var setupPrivate,
        privateObjects = {};

    var SetupPrivateModelPrototype = {

        name: 'SetupPrivateModel',
        route: 'apiSetupPrivateModel',
        defaults: {
            'address': [],
            'cart': {id_cart:'current'},
            'customer': {},
            'sync':false,
            'message': []
        },
        isSync:false,
        privateApi:true,

        initialize: function ()
        {

            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this, arguments);
            //

            setupPrivate = this;

            setupPrivate.on('sync', setupPrivate.onSetupPrivate, setupPrivate);
            // force la synchronisation distante
        },
        setup:function(){
            if(!setupPrivate.get('sync')){
                setupPrivate.fetch();
            }else{
                setupPrivate.trigger('setupPrivate',privateObjects);
            }
        },
        url:function(){
            var store_preset = site_vars.store_preset, url = ObjectModel.prototype.url.apply(this, arguments);
            if(store_preset){
                url+='?store_preset='+store_preset;
            }
            return url;
        },
        updateSync:function(wsMessage){
            var sync = privateObjects.sync;
            if(sync){
                sync.set(wsMessage.data);
                window.location.reload(true);
            }
        },
        onSetupPrivate: function ()
        {
            //
            setupPrivate.isSync = true;
            // instancie tous les objets issus du JSON en model et collection Backbone
            _(setupPrivate.attributes).each(function (object, key)
            {
                // essaie de fabriquer le constructeur des collections
                var constructorName = key[0].toUpperCase() + key.slice(1);
                switch (key) {
                    case 'message':
                    case 'address':
                        constructorName = constructorName + 'Collection';
                        break;
                    default : // cart, customer, sync
                        constructorName = constructorName + 'Model';
                }
                try {
                    var constructor = eval(constructorName);
                } catch (err) {
                    return;
                }
                var o;
                if(key == 'cart'){
                    //
                    // le constructeur panier est contextualisé
                    // chaque panier a un constructeur unique, si on instancie plusieurs panier
                    //
                    constructor = CartModel.getConstructor();
                }
                o = privateObjects[key] = new constructor(object);
                o.trigger('sync', o);
            });
            setupPrivate.trigger('setupPrivate',privateObjects);
        },
    };


    var SetupPrivateModel = ObjectModel.extend(SetupPrivateModelPrototype);

    return SetupPrivateModel;
});

